import { Injectable }                        from "@angular/core";
import { Response } from "@angular/http";
import { CONFIGURATION }                     from "../../../app.constants";
import { Pagination, EmailTemplate }                  from "../../../models";
import { Observable }                        from "rxjs/Observable";
import { HttpDataService }                   from "../../../services/shared";

@Injectable()
export class EmailTemplatesService {

    constructor(private httpData: HttpDataService) { }

    // Retrieve a list of EmailTemplate objects based on the pagination filters
    public GetEmailTemplateList(pagination: Pagination, sortOrder: string, sortColumn: string): Observable<Response> {
        let filter = "";
        let order: string = "&$orderby=" + sortColumn + " " + sortOrder;
        let skip: any = (pagination.currentPage - 1) * pagination.itemsPerPage;
        let dataUrl = `${CONFIGURATION.baseUrls.apiUrl}EmailTemplate?$skip=${skip}&$top=${pagination.itemsPerPage}&$count=true${filter}${order}`;
        //     let dataUrl = CONFIGURATION.baseUrls.apiUrl + "message/search?" + "$skip=" + skip + "&$top=" + pagination.itemsPerPage + "&$count=true" + filter + order;        
        return Observable.create((observer) => {
            this.httpData.get(dataUrl)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    // Retrieve a single EmailTemplate object based on the Code or EmailTemplateCodeId value
    public GetEmailTemplate(code: string): Observable<Response> {
        let dataUrl = `${CONFIGURATION.baseUrls.apiUrl}EmailTemplate/${code}`;
        return Observable.create((observer) => {
            this.httpData.get(dataUrl)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public Save(template: EmailTemplate): Observable<EmailTemplate> {
        return Observable.create((observer) => {
            this.httpData.put(CONFIGURATION.baseUrls.apiUrl + "EmailTemplate", JSON.stringify(template))
                .map(response => <EmailTemplate>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/userHome/emailTemplates/emailTemplates.service.ts